import { inject, Pipe, PipeTransform } from '@angular/core';
import { FileSignatureController } from '@shared/controllers/file-signature.controller';
import { privateFile } from '@shared/helpers/private-file.helper';
import { publicFile as _publicFile } from '@shared/helpers/public-file.helper';

@Pipe({
  name: 'authFile'
})
export class AuthFilePipe implements PipeTransform {
  private readonly fs = inject(FileSignatureController);

  transform(src: string, width?: number, height?: number, publicFile?: boolean): string | undefined {
    if (!src) return;

    if (publicFile) return _publicFile(src);

    const privateFilePath = privateFile(src);
    return this.appendDimensions(this.resolvePrivateFilePath(privateFilePath), width, height);
  }

  getPrivateFile(src: string, width?: number, height?: number): string | undefined {
    if (!src) return;

    return this.appendDimensions(this.resolvePrivateFilePath(privateFile(src)), width, height);
  }

  private appendDimensions(path: string, width?: number, height?: number): string {
    if (!width) return path;

    const resolvedHeight = height ?? width;
    return `${path}&width=${width}&height=${resolvedHeight}`;
  }

  private resolvePrivateFilePath(privateFilePath: string): string {
    const signature = this.fs.getSignature();
    if (signature) {
      return `${privateFilePath}?token=${signature}`;
    }

    const projectFormToken = this.fs.sharedProjectFormToken;
    if (projectFormToken) {
      return `${privateFilePath}?projectFormToken=${projectFormToken}`;
    }

    const sharedAccessToken = this.fs.sharedAccessToken;
    if (sharedAccessToken) {
      return `${privateFilePath}?shareToken=${sharedAccessToken}`;
    }

    return privateFilePath;
  }
}
